<script lang="ts" setup>
import { defineProps, ref, watch } from 'vue'
import { Studio } from '@/modules/Studios/types'
import GmapsPlaceInput from '@/components/GmapsPlaceInput.vue'

const props = defineProps<{
  studio: Studio
}>()

const location = ref({
  address: props.studio.locationAddress || '',
  lat: props.studio.locationLat || 0,
  lng: props.studio.locationLng || 0,
})

watch(
  () => location.value,
  (value) => {
    props.studio.locationAddress = value.address
    props.studio.locationLat = value.lat
    props.studio.locationLng = value.lng
  },
  { deep: true }
)
</script>

<template>
  <div class="studio-location">
    <p class="location-title">Location</p>
    <GmapsPlaceInput
      v-model="location"
      placeholder="Address of the studio"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.studio-location {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.location-title {
  margin: 0;
  color: var(--color-dark-800);
}
</style>
